import "./SelectSheet.css";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const SelectSheet = ({ sheetNames, currentPdfIndex, setCurrentIndex }) => {
  const handleChange = (e) => {
    setCurrentIndex(sheetNames.indexOf(e.target.value));
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      height="100%"
      sx={{ marginLeft: "58px" }}
    >
      <FormControl
        sx={{
          width: "210px",
          height: "30px",
        }}
      >
        <Select
          value={sheetNames[currentPdfIndex]}
          onChange={handleChange}
          size="small"
          sx={{
            justifyContent: "center",
            color: "title.main",
            fontSize: "12px",
            fontWeight: "bold",
            boxShadow: "0px 0px 10px 2px rgba(0, 0, 0, 0.3)",
            backgroundColor: "background.third",
            "& .MuiSelect-icon": {
              color: "primary.main",
            },
            // remove border when clicked and hovered
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          }}
        >
          {sheetNames.map((sheetName, index) => (
            <MenuItem
              key={index}
              value={sheetName}
              sx={{
                fontSize: "12px",
                color: "title.main",
              }}
            >
              {sheetName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectSheet;
